<!-- CheckboxMapYN.vue -->
<script lang="ts" setup>
import { computed } from 'vue';
import { hasSlot } from '../../lib/VueHelpers'
import Checkbox from './Checkbox.vue';

    const props = defineProps<{
        modelValue?: any,
        disabled?: boolean
        title?: string
    }>();

    const trueVal = "Y";
    const falseVal= "N";   

    const emits = defineEmits<{
        "update:modelValue": [val: any]
    }>();


    const booleanValue = computed<boolean|undefined>(() =>{
        if (trueVal == props.modelValue)
            return true;
        if (falseVal == props.modelValue)
            return false;
        return;
    });

    function emitValue(val: boolean|undefined)
    {
        switch(val)
        {
            case true:
            emits("update:modelValue", trueVal);
            return;

            case false:
            emits("update:modelValue", falseVal);
            return;

            default:
            emits("update:modelValue", undefined);
            return;
        }
    }
    
</script>

<template>
    <Checkbox 
        :modelValue="booleanValue"
        @update:modelValue="emitValue"
        :disabled="props.disabled"
        :title="props.title">
        <template v-if="hasSlot()">
            <slot></slot>
        </template>
    </Checkbox>
</template>